var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AlertCaseDetailsContent',{attrs:{"case-id":_vm.case_id},on:{"onRefresh":_vm.getAlertCase}})
}
var staticRenderFns = []

export { render, staticRenderFns }